import Svg from '@doordash/component-svg'
import * as React from 'react'
import { ImageProps } from '../'
import t from './strings'

// tslint:disable:max-line-length
export const Money: React.FunctionComponent<ImageProps> = ({
  width,
  height,
}) => (
  <Svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 60 59"
    aria-labelledby="valuePropsTitleMoney valuePropsDescMoney"
    role="img"
  >
    <title id="valuePropsTitleMoney">{t.title()}</title>
    <desc id="valuePropsDescMoney">{t.desc()}</desc>
    <defs>
      <path id="a" d="M0 0h50.4v34.3H0z" />
      <path id="c" d="M0 0h10.7v10.7H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0-1h60v60H0z" />
      <path
        fill="#528C8F"
        d="M38.6 10.9l-2.7 44.8-22-1.3S15.2 10 16 9.7c.6-.2 22.6 1.2 22.6 1.2"
      />
      <path
        fill="#457C7C"
        d="M35.4 14.3L33 53.6s-15.7-1-16.9-1.4c-.4-.2 2.2-38.3 2.2-38.3l17 .4z"
      />
      <path
        fill="#74A3A5"
        d="M53.6 18L30.2 56.8 10.7 46.4s22-39 22.8-38.9c.6 0 20 10.5 20 10.5"
      />
      <path
        fill="#528C8F"
        d="M49.3 18.1L28.9 53.6S16 46.3 15 45.3c-.3-.3 19.7-34.6 19.7-34.6l14.6 7.4z"
      />
      <path
        fill="#74A3A5"
        d="M36.1 23.6a6 6 0 013.2 1.3c1.1.9 1.6 2 1.4 3.2a5.6 5.6 0 01-3.6 4.7c-.8.3-1.6.5-2.5.4a3.5 3.5 0 01-1.3-.5 7.7 7.7 0 01-2.8-2.7c-.5-.8-.6-1.7-.3-2.7.6-2 2.4-3.6 4.8-3.7h1.1m-9 21.3c.4.4.6 1 .7 1.6a2 2 0 01-.6 1.8c-.9.8-1.9 1.2-3 .9-.5-.2-.9-.4-1.2-.7a1.7 1.7 0 01-.3-.7c-.2-.7-.3-1.4-.1-2 .1-.6.4-1 .8-1.3 1-.7 2.3-.8 3.3 0l.3.4M43.1 17c.4.4.7 1 .8 1.7a2 2 0 01-.6 1.8c-1 .8-2 1.1-3 .8-.5-.1-.9-.3-1.2-.7a1.7 1.7 0 01-.3-.6c-.2-.7-.3-1.4-.1-2.1 0-.6.4-1 .8-1.3 1-.7 2.2-.7 3.2 0l.4.4"
      />
      <g transform="translate(5.4 24.6)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#FF4D2B"
          d="M34.6 34.1c-5 0-10 0-15 .2L0 34C-.3 34.1.5 1 1.7.6c2.9-1 35-.5 40.7-.4 1.6 0 4.8-.2 6.3.3.6.1 2.1 32.9 1.5 33-2.5.4-6.3.4-8.8.5l-6.8.1"
          mask="url(#b)"
        />
      </g>
      <path
        stroke="#FF4D2B"
        d="M6.5 4.8c-.1.2-.1.4.2.5.3 0 2.5.5 3.2 1.6.5 1 1 2.6 1.2 2.7l.4-.1c0-.1.4-2.7 1.3-3.3 1-.7 3.3-.9 3.3-1.3 0-.2-1-.3-1.9-.6-.9-.2-2.1-1.1-2.4-2A8 8 0 0011 0c-.2 0-.2 2.1-1 2.9a6 6 0 01-2 1.3c-.7.3-1.4.4-1.5.6z"
      />
      <g transform="translate(49.3 12.9)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          fill="#F3B5AD"
          d="M0 5.4c0 .2 0 .4.3.5.4.1 2.8.5 3.6 1.8.6 1 1.2 2.9 1.4 3l.5-.1c0-.2.4-3 1.3-3.7 1.2-.8 3.6-1 3.6-1.6 0-.2-1-.3-2-.6-1-.2-2.5-1.2-2.8-2.2-.2-1-.7-2.5-1-2.5-.1 0 0 2.4-1 3.2-.7.8-1.4 1.3-2.2 1.6-.7.3-1.6.4-1.6.6"
          mask="url(#d)"
        />
      </g>
      <path
        stroke="#FF4D2B"
        d="M47.2 7.5v.2c.2 0 1.2.2 1.5.8l.6 1.1h.1s.2-1.2.6-1.5c.4-.3 1.4-.4 1.4-.6l-.8-.2c-.4-.1-1-.5-1-1l-.5-1s0 1-.4 1.3c-.3.4-.6.5-.9.7l-.6.2z"
      />
      <path
        fill="#457C7C"
        d="M0 11.3c0 .1 0 .2.2.3.1 0 1.4.2 1.8.8l.7 1.5h.2c0-.1.2-1.6.7-1.9.5-.4 1.8-.5 1.8-.8l-1-.3c-.6 0-1.3-.6-1.4-1l-.5-1.3c-.1 0-.1 1.2-.5 1.6L.9 11l-.9.3"
      />
      <path
        fill="#F3B5AD"
        d="M8.3 16s-.2.2-.1.3c0 .2.5 1.3.1 2l-.8 1.3c0 .2.1.2.2.2 0 0 1.3-.7 1.8-.5.6.3 1.4 1.2 1.6 1l-.3-1c-.2-.4-.1-1.3.2-1.6l.8-1.1c0-.1-1 .6-1.6.4a3 3 0 01-1.2-.4l-.7-.5"
      />
      <path
        fill="#FF3008"
        d="M42.6 36.9c-.9.7-1.8 2.5-1.9 4.4 0 2 .5 4 1.1 4.7 2 2.1 5.2 2.2 5.2 2.2a317.3 317.3 0 0012-.3s0-11.6-.6-12.3c-.4-.5-10.1 0-11.3 0-1.2-.1-3.2.1-4.5 1.3"
      />
      <path
        stroke="#E6E5D8"
        strokeWidth="0.8"
        d="M49 41c.3.5.3 1 .2 1.5 0 .6-.4 1-1 1.2-.8.3-1.7.3-2.5-.3a1.8 1.8 0 01-.6-.8 1.4 1.4 0 01-.1-.6c0-.5.2-1 .5-1.6.2-.4.6-.6 1-.7 1-.2 1.9 0 2.4 1l.2.3"
      />
      <path
        fill="#F3B5AD"
        d="M58.4 35.6c-.2-.2-1.2-.2-2.7-.2.3 4 .5 8.8.6 12.8 2 0 2.6-.2 2.6-.2s.2-11.6-.5-12.4"
      />
      <path
        fill="#FF3008"
        d="M7.7 26.1l5.2-.4s-.5 32.2-1.3 32.8c-.8.6-5.2.4-5.2.4l.3-18.4 1-14.4z"
      />
    </g>
  </Svg>
)

export default Money
